import $ from "jquery";

const header = {
    timer: null,

    init() {
        $(".lux-main-menu .lux-menu-link").hover(
            function (e) {
                if ($(".search-result-overlay").is(":visible")) return;
                const id = $(this).attr("data-id");

                header.timer = setTimeout(() => {
                    $(".lux-main-menu-overlay").show();
                    $(".lux-section-menu").hide();
                    $(`.lux-section-menu[data-id=${id}]`).css(
                        "display",
                        "grid",
                    );
                }, 100);
            },
            () => {
                clearTimeout(header.timer);
            },
        );

        $(".lux-main-menu-overlay").hover((e) => {
            $(".lux-main-menu-overlay").show();
        });

        $(".lux-main-menu, .lux-main-menu-overlay").mouseleave(() => {
            $(".lux-main-menu-overlay").hide();
        });
    },
};
window.header = header;
$(() => {
    header.init();
});

$(".lux-main-menu-overlay .lux-section-menu").mouseover(function () {
    const dataId = $(this).attr("data-id");

    $(".lux-main-menu .lux-menu-link").each(function () {
        if (dataId == $(this).attr("data-id")) {
            $(this).addClass("hover");
        }
    });
});

$(".lux-main-menu-overlay .lux-section-menu").mouseleave(function () {
    const dataId = $(this).attr("data-id");

    $(".lux-main-menu .lux-menu-link").each(function () {
        if (dataId == $(this).attr("data-id")) {
            $(this).removeClass("hover");
        }
    });
});

const searchButton = document.querySelector(".lux-header .lux-search-button");

if (searchButton) {
    searchButton.addEventListener("click", function () {
        document.getElementById("search-input-field")?.click();
    });
}

export default header;
